import * as React from 'react'
import {
  Dialog, DialogActions, DialogContent, DialogContentText, withStyles, WithStyles
} from '@material-ui/core'
import DialogTitle from '@components/DialogTitle'
import captchaDialogStyles from './styles/CaptchaDialogStyle'
import AdornedButton from '@components/AdornedButton'
import CaptchaInput from './CaptchaInput'
import { transform } from '@utils/intl_lang'
interface IProps extends WithStyles<typeof captchaDialogStyles> {
  captcha: string
  captchaError: boolean
  captchaUrl: string
  onClose: () => void
  handleCaptchaChange: (event: any) => void
  handleUpdateCaptchaImg: () => void
  captchaPass: () => void
}

const CaptchaImgDialog: React.SFC<IProps> = props => {
  const {
    captcha,
    captchaError,
    captchaUrl,
    handleCaptchaChange,
    handleUpdateCaptchaImg,
    onClose,
    captchaPass,
    classes,
  } = props

  React.useEffect(() => {
    handleUpdateCaptchaImg()
  }, [])

  return (
    <Dialog
      open={true}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle onClose={onClose} />
      <DialogContent className={classes.dialogContent}>
        <CaptchaInput
          captchaError={captchaError}
          captcha={captcha}
          handleCaptchaChange={() =>handleCaptchaChange(event)}
          handleUpdateCaptchaImg={handleUpdateCaptchaImg}
          captchaUrl={captchaUrl}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <AdornedButton
          variant="contained"
          onClick={captchaPass}
          color="primary"
          className={classes.okBtn}
          loading={false}
        >
          {/* 确 定 */}
          {transform('confirm_empty')}
        </AdornedButton>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(captchaDialogStyles)(CaptchaImgDialog)
